/** @jsxImportSource @emotion/react */

import tw from "twin.macro";
import { AliErrorResponse } from "../../services/DiscrepancyType";

import { CalciteTooltip } from "@esri/calcite-components-react";
import React from "react";

const CallGenerated: React.FC<AliErrorResponse> = (data, error) => {
  const originalData = {
    "Telephone Number": data.error.ORG_TELNUM,
    Name: data.error.ORG_NAME,
    Address: data.error.ORG_ADDR,
    Location: data.error.ORG_LOCINFO,
    Community: data.error.ORG_COMM,
    ESN: data.error.ORG_ESN,
  };
  const changedData = {
    "Telephone Number": data.error.EDIT_TELNUM,
    Name: data.error.EDIT_NAME,
    Address: data.error.EDIT_ADDR,
    Location: data.error.EDIT_LOCINFO,
    Community: data.error.EDIT_COMM,
    ESN: data.error.EDIT_ESN,
  };
  const issueData = {
    Issue: [
      data.error.CHK_ALI === "True" && "Incorrect ALI",
      data.error.CHK_MISROUTE === "True" && "Misroute",
      data.error.CHK_NORECORD === "True" && "NRF",
      data?.discrep?.dtype && data.discrep.dtype,
    ]
      .filter(Boolean)
      .join(", "),
    Timestamp: data.error.TIMESTAMP,
    PSAP: data.error.PSAP_NAME,
    "Date Time Call": data.error.DATE_TIME_CALL,
    "Call Type": data.error.CALLTYPE,
    "Call Taker Name": data.error.CALLTAKER_NAME,
  };
  return (
    <div css={[tw`col-span-2 `]}>
      <h3 css={[tw`mb-2`]}>Call Taker Generated</h3>
      <div css={[tw`grid w-full md:grid-cols-2 gap-6`]}>
        <div
          css={[
            tw`border-r border-t border-l border-gray-300 rounded-md overflow-hidden`,
          ]}
        >
          <table css={[tw`w-full`]}>
            <thead css={[tw`bg-gray-200 border-b border-gray-400`]}>
              <tr css={[tw`text-left`]}>
                <th css={[tw`border-r border-gray-400 p-2`]}></th>
                <th css={[tw`font-semibold border-r border-gray-400 p-2`]}>
                  Original
                </th>
                <th css={[tw`border-gray-400 font-semibold p-2`]}>Edit</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(originalData).map((field) => (
                <tr
                  key={field}
                  css={[
                    originalData[field] !== changedData[field] &&
                      originalData[field] !== null &&
                      tw`bg-yellow-600`,
                    tw`border-b border-gray-300`,
                  ]}
                >
                  <td
                    css={[
                      tw` w-1/3 font-semibold border-r border-gray-400 p-2`,
                    ]}
                  >
                    {field}
                  </td>
                  <td css={[tw`border-r border-gray-400 p-2`]}>
                    {originalData[field]}
                  </td>
                  <td css={[tw`border-gray-400 p-2`]}>{changedData[field]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div
          css={[
            tw`border-r border-t border-l border-gray-300 rounded-md overflow-hidden`,
          ]}
        >
          <table css={[tw`w-full`]}>
            <tbody>
              {Object.keys(issueData).map((field) => (
                <tr key={field} css={[tw`border-b border-gray-300`]}>
                  <td
                    css={[tw`w-1/4 font-semibold border-r border-gray-400 p-2`]}
                  >
                    {field}
                  </td>
                  <td css={[tw`p-2`]}>{issueData[field]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div css={[tw`border border-gray-300 rounded-md overflow-hidden`]}>
          <h3 css={[tw`border-b border-gray-300 bg-gray-200 p-2`]}>Comments</h3>
          <div css={tw`p-2`}>{data.error.COMMENTS}</div>
        </div>
        <div
          css={[tw`max-h-96 border border-gray-300 rounded-md overflow-y-auto`]}
        >
          <CalciteTooltip referenceElement={"ali"} placement="right">
            Copy to Clipboard
          </CalciteTooltip>
          <div css={[tw`border-b border-gray-300 bg-gray-200 p-2`]}>
            <h3
              id="ali"
              css={[tw`cursor-pointer w-fit m-0`]}
              onClick={() =>
                navigator.clipboard.writeText(data.error.ALI || "")
              }
            >
              ALI
            </h3>
          </div>

          <div css={tw`p-2`}>
            <pre css={tw`whitespace-pre-wrap break-normal`}>
              {data.error.ALI}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallGenerated;
